function getLocalIdReduxUtil (instance) {
  if (!instance || !instance.cid) {
    return
  }
  return instance.cid * -1
}

export default getLocalIdReduxUtil
